import { publicRequest, userRequest } from "../../../requestMeth";
import {
  alertsStart,
  alertsSuccess,
  alertsFailure,
  deleteStart,
  deleteSuccess,
  deleteFailure
} from "../../reducers/alertsRedux";

export const getAllAlerts = async (dispatch, token, params = {}) => {
  dispatch(alertsStart());
  try {
    const res = await publicRequest.get("/alerts", {
      headers: { token: `Bearer ${token}` },
      params, // <-- { q }
    });
    dispatch(alertsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertsFailure());
  }
};

export const getAlertById = async (dispatch, id, token) => {
  dispatch(alertsStart());
  try {
    const res = await publicRequest.get(`/alerts/${id}`, {
      headers: { token: `Bearer ${token}` }
    });
    dispatch(alertsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertsFailure());
  }
};

export const getCostUnitPreview = async (deviceId, service) => { 
  try {
    const persistedRedux = localStorage.getItem("persist:root");
    let token = "";
    if (persistedRedux) {
      const parsed = JSON.parse(persistedRedux);
      const userState = JSON.parse(parsed.user);
      token = userState?.currentUser?.accessToken || "";
    }
    const res = await publicRequest.get(
      `alerts/cost-unit-preview?deviceId=${deviceId}&service=${service}`,
      {
        headers: { token: `Bearer ${token}` }
      }
    );
    return res.data;
  } catch (error) {
    console.error("Error en getCostUnitPreview:", error);
    throw error;
  }
};

export const createAlert = async (dispatch, alert, token) => {
  dispatch(alertsStart());
  try {
    const res = await publicRequest.post("/alerts", alert, {
      headers: { token: `Bearer ${token}` }
    });
    dispatch(alertsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertsFailure());
  }
};

export const updateAlert = async (dispatch, id, alert, token) => {
  dispatch(alertsStart());
  try {
    const res = await publicRequest.put(`/alerts/${id}`, alert, {
      headers: { token: `Bearer ${token}` }
    });
    dispatch(alertsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertsFailure());
  }
};

export const deleteAlert = async (dispatch, id, token) => {
  dispatch(deleteStart());
  try {
    const res = await publicRequest.delete(`/alerts/${id}`, {
      headers: { token: `Bearer ${token}` }
    });
    dispatch(deleteSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(deleteFailure());
  }
};
